var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticStyle:{"background-color":"rgb(247 248 249)"}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }